export default "__VITE_ASSET__BTzt3AVX__"